<template>
	<div class="page">
		<HeaderBar title="乙肝病毒DNA"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400dna.guid">
					<checkItem v-for="(item,index) in dataList" :key="index" :config="item" @setFormData="setFormData"
						v-model="form.bq400dna">
					</checkItem>
					<FormNormalInput label="对数" v-model="form.bq400dna.bq400055" readonly />
				</van-cell-group>
				<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq400dna.guid'></FormNormalUpload>

				<div class="page-bottom-box" style="margin: 16px;"  v-show='!savestate'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq400dna.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>

	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page003",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400dna',
				form: {
					bq400dna: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400053: "", //乙肝病毒DNA
						bq4000532: "", //值
						bq4000533: "", //单位
						bq4000542: "", //病毒指数符号
						bq400054: "", //病毒指数
						bq400055: "", //病毒对数
						Bq400_guid: '', //随访基本信息表编号
						Bq400_053: '', //乙肝病毒DNA
						Bq400_053_2: '', //值
						Bq400_053_3: '', //单位
						Bq400_054_2: '', //病毒指数符号
						Bq400_054: '', //病毒指数
						Bq400_055: '', //病毒对数
					},
					sempFiles: []
				},

				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400dna/Save',
				dataList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400')),
				savestate:false,
			}
		},
		components: {
			...componentsModel
		},
		methods: {

			//加载信息
			LoadInfo: function() {
				var that = this				
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 +  '/api/S400Bq400dna/Info',args, function(d) {
					console.log(d.Data)
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$set(that.form, "bq400dna", dataModel)
					}
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
			
				if(that.form.bq400dna.bq400053==''){
					that.form.bq400dna.bq400053=that.form.bq400dna.bq400054=that.form.bq400dna.bq400055=''
				}
				that.savestate=true
				that.$utils.CopyKeySave(that.form.bq400dna, that.form.bq400dna)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			}, //自动计算BMI
			CalZS: function() {
				if (isNaN(this.form.bq400dna.bq4000532) || parseFloat(this.form.bq400dna.bq4000532) == 0 || isNaN(this
						.form.bq400dna.bq400054) || parseFloat(this.form.bq400dna.bq400054) == 0) {
					alert('error')
				}
				this.form.bq400dna.bq400055 = (parseFloat(this.form.bq400dna.bq4000532) + Math.log10(parseFloat(this
					.form
					.bq400dna.bq400054))).toFixed(2)
			}
		},
		mounted() {
			this.form.bq400dna.bq400guid = this.bq400.guid
			this.LoadDataList()
			this.LoadInfo()
		},
		watch: {
			'form.bq400dna.bq4000532': {
				handler: function() {
					this.CalZS()
				},
			},
			'form.bq400dna.bq400054': {
				handler: function() {
					this.CalZS()
				},
			}
		},
	}
</script>

<style scoped>

</style>
